export default __webpack_public_path__ + "static/media/product_01.3e4e2689.jpg";